"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fundsRepository = exports.FundsRepository = void 0;
const client_1 = require("../client");
class FundsRepository {
    get db() {
        return (0, client_1.getSupabase)();
    }
    /**
     * Add a single funds transaction
     */
    async addTransaction(transaction) {
        const { data, error } = await this.db
            .from('funds_transactions')
            .insert(transaction)
            .select()
            .single();
        if (error)
            throw error;
        return data;
    }
    /**
     * Add multiple transactions in bulk
     */
    async addTransactions(transactions) {
        if (transactions.length === 0) {
            return [];
        }
        const { data, error } = await this.db
            .from('funds_transactions')
            .insert(transactions)
            .select();
        if (error)
            throw error;
        return data;
    }
    /**
     * Get transactions by account
     */
    async getTransactions(accountId, options) {
        const limit = options?.limit || 100;
        const offset = options?.offset || 0;
        let query = this.db
            .from('funds_transactions')
            .select('*', { count: 'exact' })
            .eq('account_id', accountId);
        if (options?.startTime) {
            query = query.gte('transaction_time', options.startTime);
        }
        if (options?.endTime) {
            query = query.lt('transaction_time', options.endTime);
        }
        query = query
            .order('transaction_time', { ascending: false })
            .range(offset, offset + limit);
        const { data, error, count } = await query;
        if (error)
            throw error;
        const hasMore = count ? offset + limit < count : false;
        const continuationToken = hasMore
            ? btoa(JSON.stringify({ offset: offset + limit }))
            : undefined;
        return {
            data: data || [],
            continuationToken,
            hasMore,
            total: count || 0,
        };
    }
    /**
     * Get transaction by ticket
     */
    async getTransactionByTicket(ticket) {
        const { data, error } = await this.db
            .from('funds_transactions')
            .select('*')
            .eq('ticket', ticket)
            .single();
        if (error) {
            if (error.code === 'PGRST116') {
                return null;
            }
            throw error;
        }
        return data;
    }
    /**
     * Update a transaction
     */
    async updateTransaction(id, updates) {
        const { data, error } = await this.db
            .from('funds_transactions')
            .update(updates)
            .eq('id', id)
            .select()
            .single();
        if (error)
            throw error;
        return data;
    }
    /**
     * Delete a transaction
     */
    async deleteTransaction(id) {
        const { error } = await this.db
            .from('funds_transactions')
            .delete()
            .eq('id', id);
        if (error)
            throw error;
    }
    /**
     * Get balance for account at a specific time
     */
    async getBalanceAtTime(accountId, timestamp) {
        const { data, error } = await this.db
            .from('funds_transactions')
            .select('amount')
            .eq('account_id', accountId)
            .lte('transaction_time', timestamp)
            .order('transaction_time', { ascending: true });
        if (error)
            throw error;
        return data.reduce((sum, t) => sum + t.amount, 0);
    }
}
exports.FundsRepository = FundsRepository;
// Export singleton instance
exports.fundsRepository = new FundsRepository();
